import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Flex } from 'hljd'

@observer
export default class extends Component {
  render() {
    const { answer_count, title, answer } = this.props

    return (
      <div style={{ marginBottom: 10 }}>
        <Flex vc sp>
          <Flex vc>
            <img
              src="//qnm.hunliji.com/o_1cir9embs1blv128e1siuea6l359.png"
              style={{
                width: 16,
                height: 16,
                marginRight: 5,
                flexShrink: 0
              }}
            />

            <span style={{ fontSize: 15 }}>{title}</span>
          </Flex>

          <p style={{ fontSize: 13, flexShrink: 0, marginLeft: 10 }}>
            {answer_count}回答
          </p>
        </Flex>

        {answer && (
          <Flex style={{ marginTop: 10, flexShrink: 0 }} vc>
            <img
              src="//qnm.hunliji.com/o_1cir9embs6uhmlejk0d5l19ld8.png"
              style={{ width: 16, height: 16, marginRight: 5 }}
            />
            <span>{(answer || {}).content}</span>
          </Flex>
        )}
      </div>
    )
  }
}
